var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Logo',[_c('LogoImage',{attrs:{"src":_vm.LogoImageSrc}}),_c('SubtitleArea',[_c('span',{staticClass:"italic text"},[_vm._v("Very ")]),_vm._v("good. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }